import { render, staticRenderFns } from "./GlobalRecordingManager.vue?vue&type=template&id=640b19b8&"
import script from "./GlobalRecordingManager.vue?vue&type=script&lang=js&"
export * from "./GlobalRecordingManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports